import { render, staticRenderFns } from "./jjzm.vue?vue&type=template&id=995177bc&"
import script from "./jjzm.vue?vue&type=script&lang=js&"
export * from "./jjzm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports